module.exports = __webpack_public_path__ + "static/media/spotify.f1fe294a.svg";